export interface ArticlePreview {
  slug: string;
  titleKey: string;
  summaryKey: string;
  dateKey: string;
  category: string;
  image: string;
}

export const articlePreviews: ArticlePreview[] = [
  {
    slug: "allchinabuy-spreadsheet",
    titleKey: "article1.title",
    summaryKey: "article1.summary",
    dateKey: "article1.date",
    category: "Spreadsheet",
    image: "https://readdy.ai/api/search-image?query=Modern%20laptop%20displaying%20colorful%20data%20spreadsheet%20with%20charts%2C%20clean%20bright%20desk%20with%20small%20plant%20and%20coffee%20cup%2C%20fresh%20airy%20workspace%2C%20soft%20natural%20light%2C%20minimal%20aesthetic&width=800&height=500&seq=article-spreadsheet&orientation=landscape&nocache=true",
  },
  {
    slug: "allchinabuy-review",
    titleKey: "AllChinaBuy Review 2026: Features, Pros, Cons & Buying Guide",
    summaryKey: "A comprehensive review of the AllChinaBuy platform, covering features, warehouse services, shipping options, and honest pros and cons for international buyers.",
    dateKey: "Updated August 2026",
    category: "Review",
    image: "https://readdy.ai/api/search-image?query=Close-up%20of%20hands%20holding%20tablet%20reviewing%20online%20products%20with%20star%20ratings%2C%20cozy%20cafe%20background%2C%20soft%20warm%20lighting%2C%20editorial%20lifestyle%20photography%2C%20neutral%20tones&width=800&height=500&seq=article-review&orientation=landscape&nocache=true",
  },
  {
    slug: "allchinabuy-shipping",
    titleKey: "AllChinaBuy Shipping Cost 2026: Complete Guide & Comparison",
    summaryKey: "Everything you need to know about AllChinaBuy shipping costs, delivery times, shipping lines, and how to calculate volumetric weight for international orders.",
    dateKey: "Updated August 2026",
    category: "Shipping",
    image: "https://readdy.ai/api/search-image?query=Rows%20of%20brown%20cardboard%20shipping%20boxes%20with%20tape%20and%20labels%20on%20warehouse%20floor%2C%20logistics%20concept%2C%20soft%20daylight%2C%20minimalist%20industrial%20photography%2C%20warm%20neutral%20tones&width=800&height=500&seq=article-shipping&orientation=landscape&nocache=true",
  },
  {
    slug: "allchinabuy-legit",
    titleKey: "Is AllChinaBuy Legit? 2026 Safety & Trust Guide",
    summaryKey: "An honest safety guide covering seller trust, payment security, counterfeit risks, and red flags to watch for when buying through AllChinaBuy.",
    dateKey: "Updated August 2026",
    category: "Safety",
    image: "https://readdy.ai/api/search-image?query=Large%20shield%20with%20checkmark%20icon%20standing%20on%20soft%20blue%20pastel%20background%2C%20digital%20trust%20and%20safety%20concept%2C%20minimalist%20illustration%20style%2C%20clean%20modern%20aesthetic&width=800&height=500&seq=article-safety&orientation=landscape&nocache=true",
  },
  {
    slug: "allchinabuy-coupon",
    titleKey: "AllChinaBuy Coupon 2026: How Discounts Work",
    summaryKey: "A complete guide to AllChinaBuy coupons, discount codes, eligibility requirements, and how to maximize savings on your orders.",
    dateKey: "Updated August 2026",
    category: "Coupons",
    image: "https://readdy.ai/api/search-image?query=Shopping%20paper%20bag%20with%20colorful%20discount%20tags%20and%20scissors%20on%20wooden%20table%2C%20savings%20concept%2C%20soft%20natural%20lighting%2C%20minimalist%20product%20photography%2C%20warm%20tones&width=800&height=500&seq=article-coupon&orientation=landscape&nocache=true",
  },
  {
    slug: "allchinabuy-warehouse",
    titleKey: "AllChinaBuy Warehouse Guide: Storage, QC & Shipping",
    summaryKey: "Learn how AllChinaBuy warehouse works, including storage time, QC inspection, package consolidation, and shipping preparation processes.",
    dateKey: "Updated August 2026",
    category: "Warehouse",
    image: "https://readdy.ai/api/search-image?query=Large%20bright%20warehouse%20interior%20with%20tall%20metal%20shelves%20full%20of%20packages%2C%20soft%20daylight%20through%20windows%2C%20industrial%20aesthetic%2C%20warm%20neutral%20tones%2C%20editorial%20photography&width=800&height=500&seq=article-warehouse&orientation=landscape&nocache=true",
  },
  {
    slug: "allchinabuy-buying-guide",
    titleKey: "AllChinaBuy Buying Guide 2026: How to Shop Smart",
    summaryKey: "A step-by-step buying guide covering product selection, seller research, order placement, and smart strategies to avoid common purchasing mistakes.",
    dateKey: "Updated August 2026",
    category: "Guide",
    image: "https://readdy.ai/api/search-image?query=Online%20shopping%20cart%20filled%20with%20clothing%20and%20boxes%20on%20pastel%20yellow%20background%2C%20ecommerce%20concept%2C%20soft%20studio%20lighting%2C%20minimalist%20product%20photography%2C%20cheerful%20warm%20tones&width=800&height=500&seq=article-buying-guide&orientation=landscape",
  },
  {
    slug: "allchinabuy-qc-guide",
    titleKey: "AllChinaBuy QC Guide: How to Read QC Photos",
    summaryKey: "Learn how to interpret QC photos, spot defects, and decide whether to approve or reject items before they ship from the warehouse.",
    dateKey: "Updated August 2026",
    category: "QC",
    image: "https://readdy.ai/api/search-image?query=Magnifying%20glass%20over%20a%20folded%20garment%20with%20detail%20inspection%2C%20quality%20control%20concept%2C%20bright%20clean%20background%2C%20soft%20lighting%2C%20minimalist%20product%20photography%2C%20fresh%20tones&width=800&height=500&seq=article-qc-guide&orientation=landscape",
  },
  {
    slug: "allchinabuy-shipping-cost",
    titleKey: "AllChinaBuy Shipping Cost 2026: Complete Guide",
    summaryKey: "Understand the factors that determine shipping costs, including weight, destination, service type, and how volumetric weight affects your total.",
    dateKey: "Updated August 2026",
    category: "Shipping",
    image: "https://readdy.ai/api/search-image?query=Calculator%20and%20measuring%20tape%20next%20to%20small%20parcel%20box%20on%20clean%20desk%2C%20shipping%20cost%20calculation%20concept%2C%20soft%20daylight%2C%20minimalist%20product%20photography%2C%20cool%20neutral%20tones&width=800&height=500&seq=article-shipping-cost&orientation=landscape",
  },
  {
    slug: "allchinabuy-discount-code",
    titleKey: "AllChinaBuy Discount Code 2026: Offers & Savings",
    summaryKey: "How AllChinaBuy discount codes work, where to find current offers, eligibility rules, and tips to apply savings to your orders.",
    dateKey: "Updated August 2026",
    category: "Coupons",
    image: "https://readdy.ai/api/search-image?query=Percent%20sign%20tag%20and%20shopping%20bags%20with%20coins%20on%20mint%20green%20background%2C%20discount%20promotion%20concept%2C%20soft%20studio%20lighting%2C%20minimalist%20product%20photography%2C%20fresh%20cheerful%20tones&width=800&height=500&seq=article-discount-code&orientation=landscape",
  },
  {
    slug: "allchinabuy-seller-guide",
    titleKey: "AllChinaBuy Seller Guide: How to Evaluate Sellers",
    summaryKey: "A practical guide to evaluating seller trustworthiness, checking reviews, understanding ratings, and reducing risk when choosing vendors.",
    dateKey: "Updated August 2026",
    category: "Sellers",
    image: "https://readdy.ai/api/search-image?query=Storefront%20with%20glowing%20five%20star%20rating%20sign%20and%20shopping%20icons%2C%20seller%20trust%20concept%2C%20warm%20cozy%20lighting%2C%20minimalist%20illustration%20style%2C%20clean%20modern%20aesthetic&width=800&height=500&seq=article-seller-guide&orientation=landscape",
  },
  {
    slug: "allchinabuy-best-finds",
    titleKey: "Best AllChinaBuy Finds 2026: Popular Products",
    summaryKey: "A curated look at the most popular AllChinaBuy finds across categories, what makes them worth buying, and how to spot quality items.",
    dateKey: "Updated August 2026",
    category: "Finds",
    image: "https://readdy.ai/api/search-image?query=Open%20treasure%20chest%20with%20sneakers%20clothing%20and%20accessories%20spilling%20out%2C%20golden%20warm%20lighting%2C%20playful%20product%20photography%2C%20vibrant%20colors%2C%20editorial%20style&width=800&height=500&seq=article-best-finds&orientation=landscape",
  },
  {
    slug: "allchinabuy-safety-guide",
    titleKey: "AllChinaBuy Safety Guide: Buyer Protection Tips",
    summaryKey: "Essential safety tips for international buyers, covering payment protection, privacy, scam prevention, and a practical buyer checklist.",
    dateKey: "Updated August 2026",
    category: "Safety",
    image: "https://readdy.ai/api/search-image?query=Padlock%20with%20shield%20and%20checklist%20document%20on%20light%20green%20background%2C%20buyer%20protection%20concept%2C%20soft%20natural%20lighting%2C%20minimalist%20flat%20lay%20photography%2C%20calm%20tones&width=800&height=500&seq=article-safety-guide&orientation=landscape",
  },
  {
    slug: "allchinabuy-beginner-guide",
    titleKey: "AllChinaBuy Beginner Guide: Getting Started",
    summaryKey: "Everything a first-time buyer needs to know, from creating an account to placing your first order and understanding the basics.",
    dateKey: "Updated August 2026",
    category: "Guide",
    image: "https://readdy.ai/api/search-image?query=Open%20road%20map%20with%20compass%20and%20shopping%20bags%20on%20light%20wooden%20table%2C%20beginner%20journey%20concept%2C%20soft%20warm%20lighting%2C%20minimalist%20flat%20lay%20photography%2C%20inviting%20tones&width=800&height=500&seq=article-beginner-guide&orientation=landscape",
  },
  {
    slug: "allchinabuy-product-research",
    titleKey: "AllChinaBuy Product Research Guide: Find Deals",
    summaryKey: "Learn how to research products effectively, compare prices across sellers, and identify genuine quality before committing to a purchase.",
    dateKey: "Updated August 2026",
    category: "Research",
    image: "https://readdy.ai/api/search-image?query=Charts%20graphs%20and%20product%20photos%20on%20laptop%20screen%20with%20notebook%2C%20market%20research%20concept%2C%20clean%20bright%20desk%2C%20soft%20natural%20light%2C%20minimalist%20aesthetic%2C%20warm%20neutral%20tones&width=800&height=500&seq=article-product-research&orientation=landscape",
  },
  {
    slug: "allchinabuy-parcel-consolidation",
    titleKey: "AllChinaBuy Parcel Consolidation: Save on Shipping",
    summaryKey: "How parcel consolidation works, when to combine packages, and how bundling items can reduce your overall shipping costs.",
    dateKey: "Updated August 2026",
    category: "Warehouse",
    image: "https://readdy.ai/api/search-image?query=Several%20small%20packages%20being%20combined%20into%20one%20large%20cardboard%20box%2C%20parcel%20consolidation%20concept%2C%20bright%20clean%20background%2C%20soft%20lighting%2C%20minimalist%20product%20photography&width=800&height=500&seq=article-consolidation&orientation=landscape",
  },
];